import { IApiListCandidateValuationsParams } from "../../../../../api/valuation/apiListCandidateValuations";
import { IApiListClientDiscardedValuationsParams } from "../../../../../api/valuation/apiListClientDiscardedValuations";

export const valuationKeys = {
  all: ["valuations"] as const,
  listForCandidate: (params: IApiListCandidateValuationsParams) => {
    return [
      ...valuationKeys.all,
      "candidate-list",
      hashForCandidateList(params),
    ];
  },
  clientDiscardedForCandidate: (
    params: IApiListClientDiscardedValuationsParams
  ) => {
    return [...valuationKeys.all, "client-discarded", params.candidateId];
  },
};

const hashForCandidateList = (params: IApiListCandidateValuationsParams) => {
  let hash = "";
  hash += params.candidateId + ":";

  return hash;
};
